import { useState, useEffect } from 'react';

// 运行环境探测
const isTauri =
  typeof window !== 'undefined' &&
  ('__TAURI_INTERNALS__' in window || '__TAURI__' in window);
// 已安装为 PWA / 主屏幕（不再提示）
const isStandalone =
  typeof window !== 'undefined' &&
  (window.matchMedia?.('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true);

const DISMISS_KEY = 'erp_desktop_banner_dismissed_at';
const DISMISS_DAYS = 7; // 关闭后 7 天内不再打扰

/**
 * 电脑浏览器顶部提示条：推荐安装 Windows 桌面版。
 * - 仅在「电脑宽屏 + 网页版（非 Tauri、非 PWA）」显示
 * - 用户点 ✕ 关闭后 7 天内不再出现
 * - 手机端不显示（手机请用小程序 / 添加到主屏幕）
 */
export default function DesktopDownloadBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isTauri || isStandalone) return;
    // 电脑宽屏判断：>= 768px 且非触屏为主（平板横屏也会显示，无妨）
    const isWide = window.innerWidth >= 768;
    if (!isWide) return;
    const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (dismissedAt && Date.now() - dismissedAt < DISMISS_DAYS * 86400_000) return;
    // 延迟 1.5 秒出现，不抢登录输入的焦点
    const t = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-[60] w-[92%] max-w-2xl bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-xl shadow-2xl px-4 py-2.5 flex items-center gap-3 animate-slide-up">
      <span className="text-xl">💻</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold leading-tight">推荐安装 Windows 桌面版</p>
        <p className="text-[11px] text-blue-100 leading-tight mt-0.5">双击即用 · 独立窗口 · 像本地软件一样运行</p>
      </div>
      <a
        href="/download"
        className="bg-white text-blue-700 text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-blue-50 transition whitespace-nowrap"
      >
        查看下载
      </a>
      <button onClick={dismiss} className="text-blue-200 hover:text-white text-lg leading-none" aria-label="关闭">✕</button>
    </div>
  );
}
